import axios from "axios";
import {VOUCHER_BASE_URL} from "../constants";

export function getAppliedVoucherByInvoice(invoiceId) {
    return axios.get(`${VOUCHER_BASE_URL}/customer/invoice`, {params: {invoiceId}}).then(res => res.data).catch(error => console.log(error));
}
